/**
 * "Does this email already have a B2B account on beneganic.com?"
 *
 * Asked by the .ch login form (Customer Gate 2.0): a customer who already holds
 * a __B2B-Kunde account on .com is handed over to .com to log in there, and
 * everybody else logs in on .ch.
 *
 *   window.beneganicLookupComB2B(email, config) -> Promise<{ exists, source }>
 *
 * config.endpoint is the Cloudflare Worker sitting in front of the .com Shopify
 * Admin API, so the Admin token never reaches the browser. It is set in
 * templates/customers/login.liquid. Expected contract:
 *
 *   GET <endpoint>?email=<urlencoded email>
 *   200 { "exists": true }   the email is a customer on .com AND carries the
 *                            __B2B-Kunde tag
 *   200 { "exists": false }  anything else
 *   any other status/shape   rejected here, and the caller falls back to
 *                            logging the customer in on .ch
 *
 * A missing endpoint is rejected the same way: there is no offline answer to
 * give, and the caller fails open onto the .ch password step.
 *
 * The answer is a yes/no about an address the visitor has just typed, so it
 * leaks nothing they did not already supply — but it is an account-existence
 * oracle, which is why the worker (not this file) is the place to rate-limit.
 */
(function () {
  var DEFAULT_TIMEOUT = 6000;

  function normalizeEmail(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function apiAnswer(email, config) {
    var endpoint = config.endpoint;
    var url = endpoint + (endpoint.indexOf('?') === -1 ? '?' : '&') + 'email=' + encodeURIComponent(email);
    var timeout = Number(config.timeout) || DEFAULT_TIMEOUT;

    /* A login form is not a place to hang: if the worker is slow, the caller
       gets a rejection and the customer logs in on .ch as usual. */
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = window.setTimeout(function () {
      if (controller) controller.abort();
    }, timeout);

    return fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'omit',
      signal: controller ? controller.signal : undefined,
    })
      .then(function (response) {
        if (!response.ok) throw new Error('B2B lookup failed with status ' + response.status);
        return response.json();
      })
      .then(function (data) {
        if (!data || typeof data.exists !== 'boolean') {
          throw new Error('B2B lookup returned an unexpected payload');
        }
        return { exists: data.exists, source: 'api' };
      })
      .finally(function () {
        window.clearTimeout(timer);
      });
  }

  function lookup(email, config) {
    config = config || {};
    var clean = normalizeEmail(email);

    if (!clean) return Promise.reject(new Error('No email to look up'));

    var endpoint = String(config.endpoint == null ? '' : config.endpoint).trim();
    if (!endpoint) return Promise.reject(new Error('No B2B lookup endpoint configured'));

    return apiAnswer(clean, Object.assign({}, config, { endpoint: endpoint }));
  }

  window.beneganicLookupComB2B = lookup;
})();
